import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard from "./scoreboard";

export class AdjustPenalties extends Handler {
    private diff: number;

    constructor(diff: number) {
        super();

        this.diff = diff;

        display.line1("ADJUST PENALTY");
        display.line2("TIMERS Y/N");
    }

    onEnter(): void {
        scoreboard.adjustPenalties(this.diff);
        clock.popHandler();
    }

    onClear(): void {
        clock.popHandler();
    }
}
